import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { CustomersContext, ICustomersContext } from '../../customersState/customersContext';
import { EntityStatus } from 'types';
import { ActiveCustomersList } from './components/ActiveCustomersList/ActiveCustomersList';
import { ArchivedCustomersList } from './components/ArchivedCustomersList/ArchivedCustomersList';
import { DeletedCustomersList } from './components/DeletedCustomersList/DeletedCustomersList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Customers.module.scss';

const Customers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, customers, currentPage, countOfItems, status } =
		useContext<ICustomersContext>(CustomersContext);

	return (
		<>
			{customers.customerCount ? (
				<div className={style.container} data-test="Customers">
					{status === EntityStatus.Active && <ActiveCustomersList />}
					{status === EntityStatus.Archived && <ArchivedCustomersList />}
					{status === EntityStatus.Deleted && <DeletedCustomersList />}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={customers.customerCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Customers;
